<template>
  <div class="app" @mouseover="manageInactivity">
    <DefaultHeader/>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <DefaultFooter/>
    <vue-snotify></vue-snotify>

    <div id="inactivity-modal-holder" v-if="inactivityModal">
      <div class="modal-wrapper">
        <div class="modal fade show" aria-modal="true" style="display: block; padding-left: 16px;">
          <div class="modal-dialog modal-md">
            <div role="document" tabindex="-1" class="modal-content">
              <header class="modal-header">
                <h5 class="modal-title">Atenção!</h5>
              </header>
              <div class="modal-body">
                <div class="text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                  </svg>
                  <h2>Você está prestes a ser desconectado devido à inatividade.
                    Interaja com o sistema para evitar sua desconexão.</h2>
                  <!-- Add Button to close the modal -->
                  <button @click="closeModal" class="btn btn-primary">Manter minha conexão ativa</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </div>

  </div>
</template>

<script>
import { Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeader from './DefaultHeader'
import DefaultFooter from './DefaultFooter'
import router from "@/router";

export default {
  name: 'DefaultContainer',
  components: {
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader
  },
  mounted() {
    this.$store.dispatch('loadCounters');

    this.manageInactivity();
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      const { breadcrumbs } = this.$store.state;

      if (breadcrumbs.length > 0) {
        return breadcrumbs;
      }

      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    errorMessage() {
      return this.$store.state.errorMessage;
    },
    nav() {
      // Conteúdo da Navegação
      const isAdmin = this.$store.state.auth.user && this.$store.state.auth.user.groups.find(g => g.name == 'admin');

      const permission_codes = this.$store.state.auth.user.permission_codes;

      const view_customer = permission_codes.includes('view_customer');
      const view_expense = permission_codes.includes('view_expense');
      const view_contract = permission_codes.includes('view_contract');
      const view_timesheet = permission_codes.includes('view_timesheet');
      const view_folder = permission_codes.includes('view_folder');

      const items = [];

      items.push({
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer'
      });

      if (isAdmin || view_customer) {
        items.push({
          title: true,
          name: 'CRM',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        });

        items.push({
          name: 'Funcionários',
          url: '/crm/employees',
          icon: 'icon-user'
        });

        items.push({
          name: 'Clientes',
          url: '/crm/customers',
          icon: 'icon-people'
        });
      }

      /* if (isAdmin) {
        items.push({
          name: 'Contatos',
          url: '/crm/contacts',
          icon: 'icon-people'
        });
      } */

      if (isAdmin || view_customer) {
        items.push({
          name: 'Fornecedores',
          url: '/crm/providers',
          icon: 'icon-cursor'
        });
      }

      if (view_expense) {
        items.push({
          title: true,
          name: 'Financeiro',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        });

        items.push({
          name: 'Financeiro',
          url: '/financials/financials',
          icon: 'icon-energy'
        });
      }

      if (isAdmin) {
        items.push({
          name: 'NR Clientes',
          url: '/financials/refund_notes_customers',
          icon: 'icon-notebook',
          badge: {
            variant: 'danger',
            // text: this.$store.state.counters.nr_customer_count
          }
        });
      }

      if (view_expense) {
        items.push({
          name: 'NR Funcionários',
          url: '/financials/refund_notes_employees',
          icon: 'icon-notebook',
          badge: {
            variant: 'danger',
            // text: this.$store.state.counters.nr_employee_count
          }
        });
      }

      if(isAdmin) {
        items.push({
          name: 'Notas Fiscais',
          url: '/notas-fiscais',
          icon: 'icon-doc',
        })
      }

      /* if (view_expense) {
        items.push({
          title: true,
          name: 'Notas de Reembolso',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        });
      } */

      /* if (isAdmin) {
        items.push({
          name: 'NR dos Clientes',
          url: '/financials/refund_notes_customers',
          icon: 'icon-notebook',
          badge: {
            variant: 'danger',
            text: this.$store.state.counters.nr_customer_count
          }
        });
      }*/

      /* if (view_expense) {
        items.push({
          name: 'NR Funcionários',
          url: '/financials/refund_notes_employees',
          icon: 'icon-notebook',
          badge: {
            variant: 'danger',
            text: this.$store.state.counters.nr_employee_count
          }
        });

        items.push({
          name: 'ND F. Pagadora',
          url: '/financials/expenses_notes_employees',
          icon: 'icon-notebook',
          badge: {
            variant: 'danger',
            text: this.$store.state.counters.nd_employee_count
          }
        });
      }*/

      if (view_contract) {
        items.push({
          title: true,
          name: 'Contrato',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        });

        items.push({
          name: 'Contratos',
          url: '/contracts',
          icon: 'icon-layers',
          // badge: {
          //   variant: 'warning',
          //   text: this.$store.state.counters.contract_expire_count
          // }
        });
      }

      if (view_timesheet) {
        items.push({
          title: true,
          name: 'Timesheet',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        });

        items.push({
          name: 'TimeSheet',
          url: '/timesheet/timesheet',
          icon: 'icon-clock'
        });
      }

      if (isAdmin) {
        items.push({
          name: 'Relatórios',
          url: '/timesheet/report',
          icon: 'icon-list',
        });
      }

      if (view_folder) {
        items.push({
          title: true,
          name: 'Pastas',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        });

        items.push({
          name: 'Pastas',
          url: '/folder/folders',
          icon: 'icon-folder'
        });
      }

      return items;
    }
  },
  watch: {
    errorMessage(newVal) {
      this.$snotify.error(newVal.message, newVal.title, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    }
  },
  data() {
    return {
      inactivityTimeout: null,
      logoutTimeout: null,
      inactivityModal: false,
      modalShownByTimer: false,
    }
  },
  methods: {
    manageInactivity() {
      // Reseta o setTimeout
      clearTimeout(this.logoutTimeout);

      this.logoutTimeout = setTimeout(() => {
          this.$store.dispatch('auth/logout')
      }, 30 * 60 * 1000); // 30 minutes
      // clearTimeout(this.inactivityTimeout);
      // clearTimeout(this.logoutTimeout);
      //
      // this.inactivityModal = this.modalShownByTimer;
      //
      // this.inactivityTimeout = setTimeout(() => {
      //   this.inactivityModal = true;
      //   this.modalShownByTimer = true;
      //
      //   this.logoutTimeout = setTimeout(() => {
      //     this.$store.dispatch('auth/logout').then(() => {
      //       // this.$router.push('/account/login'); // Redirect to login route
      //       window.location.reload();
      //     })
      //       .catch((error) => {router.push('/account/login');
      //       });
      //   }, 5 * 60 * 1000); // 5 minutes
      // }, 30 * 60 * 1000); // 15 minutes
    },
    closeModal() {
    // Hide the modal when the button is clicked
    this.inactivityModal = false;
    this.modalShownByTimer = false;
  }
  }
}
</script>

<style scoped>
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1040;
}

.modal-wrapper h2 {
  font-size: 1.25rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #454545;
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
</style>
